import React, {useRef} from "react";
import { Screen } from '~common/screen';
import { StyledScreen } from '~common/screen';
import { Styled } from './styled';
import Slider from "react-slick";
import PrevArrow from '~images/slider-prev-arrow.svg'
import { AmplitudeCounter } from "~/amplitude-counter";

const WhatLookOnpbx = () => {
  const sliderRef = useRef(null)

  const images = [
    {
      img: `${process.env.PUBLIC_DIR}/images/index_page/what-look/user-report-img.svg`,
      title: 'Отчет по сотруднику'
    },
    {
      img: `${process.env.PUBLIC_DIR}/images/index_page/what-look/missed-report-img.svg`,
      title: 'Отчет по пропущенным'
    },
    {
      img: `${process.env.PUBLIC_DIR}/images/index_page/what-look/call-history-img.svg`,
      title: 'История звонков'
    },
    {
      img: `${process.env.PUBLIC_DIR}/images/index_page/what-look/ats-settings-img.svg`,
      title: 'Настройка АТС'
    }
  ]

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    useCSS: true,
    adaptiveHeight: false,
    appendDots: (dots: any) => (
      <Styled.Dots>
        <ul style={{ margin: "0px" }}> {dots} </ul>
      </Styled.Dots>
    ),
    customPaging: (i: number) => (
      <Styled.Dot />
    ),
    responsive: [
      {
        breakpoint: 980,
        settings: {
          dots: true
        }
      }
    ]
    // afterChange: () => AmplitudeCounter('view_feadback_onlinepbx')
  };

  const next = () => {
    if (sliderRef) sliderRef.current.slickNext()
  }

  const prev = () => {
    if (sliderRef) sliderRef.current.slickPrev()
  }

  return (
    <Screen
      id='interface'
      title={<span>Как выглядит <StyledScreen.GreenText>onlinepbx</StyledScreen.GreenText></span>}
    >
      <Styled.Container>
        <Styled.Slider>
          <Slider ref={sliderRef} { ...sliderSettings }>
            {
              images.map(image => (
                <Styled.Slide>
                  <img src={image.img} alt='onpbx-img' />
                  <Styled.SlideTitle>{image.title}</Styled.SlideTitle>
                </Styled.Slide>
              ))
            }
          </Slider>
          <Styled.Prev onClick={prev}><PrevArrow /></Styled.Prev>
          <Styled.Next onClick={next}><PrevArrow /></Styled.Next>
        </Styled.Slider>
      </Styled.Container>
    </Screen>
  )
}

export { WhatLookOnpbx }
